import React from 'react'
import { AUTH_PERMISSION_KEYS } from 'constants/auth-permission-keys'
import type { AbsenceRequestTaskT, TaskT } from 'pages/Tasks/types'
import RequestDeleteButton from 'redesign/components/atoms/Buttons/request-delete-button'
import { DrawerHeaderWrapper } from 'redesign/components/molecules/drawer-header-wrapper'
import SideMenuNestedHeader from 'redesign/components/organisms/headers/side-menu-nested-header'
import type { Task } from 'shared/graphql/graphql'
import AbsenceRequestDetailsContent from '../../absence-request-details/absence-request-details-content'
import { getActionButtons } from '../../task-details-action-buttons/utils/get-action-buttons'
import type { TaskDetailContentProps } from '../types'
import AcceptAbsenceRequestContent from './accept-absence-request-content'
import { useTaskDetailContent } from './use-task-detail-content'

const TaskDetailContent: React.FC<TaskDetailContentProps> = ({
  isOffice,
  task,
  refetch,
  onGoBack,
  onClose,
  isDrawer,
  refetchTask,
  selectedTaskUuid,
  titleKey,
}) => {
  const {
    timelineItems,
    showConflicts,
    showAbsencePlannerDrawer,
    setShowAbsencePlannerDrawer,
    person,
    isBalanceDrawerOpen,
    setIsBalanceDrawerOpen,
    dateFrom,
    dateTo,
    setShowForm,
    showForm,
    onAccept,
    onDelete,
    showDeleteButton,
    onClickDeleteRequest,
  } = useTaskDetailContent({ task: task as Task, refetch, selectedTaskUuid, refetchTask, onGoBack })

  if (showForm) {
    return (
      <AcceptAbsenceRequestContent
        onAccept={() => onAccept(task as TaskT<AbsenceRequestTaskT>)}
        onGoBack={() => setShowForm(false)}
        task={task}
        timelineItems={timelineItems}
        onClose={onClose}
        isDrawer={isDrawer}
      />
    )
  }

  return (
    <DrawerHeaderWrapper
      header={
        <SideMenuNestedHeader
          onClose={onClose}
          isDrawer={isDrawer}
          titleKey={titleKey}
          onGoBack={onGoBack}
          endContent={<RequestDeleteButton showDeleteButton={showDeleteButton} onClick={onClickDeleteRequest} />}
        />
      }
      footer={getActionButtons({
        task,
        refetch,
        workflowPermissions: AUTH_PERMISSION_KEYS.workflowAbsences,
        timelineItems,
        setShowAbsenceForm: setShowForm,
        onDelete,
      })}
    >
      <AbsenceRequestDetailsContent
        items={timelineItems}
        dateFrom={dateFrom as string}
        dateTo={dateTo as string}
        isOffice={isOffice}
        showAbsencePlannerDrawer={showAbsencePlannerDrawer}
        setShowAbsencePlannerDrawer={setShowAbsencePlannerDrawer}
        previewPerson={person ?? {}}
        showConflicts={showConflicts}
        isBalanceDrawerOpen={isBalanceDrawerOpen}
        onCloseBalanceModal={() => setIsBalanceDrawerOpen(false)}
        task={task}
        extraPaddingTop
      />
    </DrawerHeaderWrapper>
  )
}

export default TaskDetailContent
